import { get, post, put } from '@api/request';

export async function fetchWorkItemTypes(
  { queueService },
  authenticationToken,
) {
  const url = `${queueService}/queue/workitemdefinitiontypesubtypes/checkin`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function checkinAppeal(
  { queueService },
  authenticationToken,
  { payload }
) {
  const url = `${queueService}/queue/workitem/checkinappeal`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchCheckInConfig(
  { publicService },
  authenticationToken,
) {
  const url = `${publicService}/public/config/checkin`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyLimitaionCompression(
  { queueService },
  authenticationToken,
  { pID, pYear, pVersion = 0, pRollCorr = 0 }
) {
  const url = `${queueService}/prodigyappraisalnotices/taxlimitation/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/compress/sample`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function compressPropertyLimitation(
  { queueService },
  authenticationToken,
  { pID, pYear, pVersion = 0, pRollCorr = 0 }
) {
  const url = `${queueService}/prodigyappraisalnotices/taxlimitation/property/${pID}/${pYear}/${pVersion}/${pRollCorr}/compress`;
  const { body } = await put(authenticationToken, url);
  return body;
}